import type { TranslationLocale } from "@hightouch/lib/cep/localization/translation-state";

/** Which workspace locales an owner can be written in or translated into. */
export type LocaleRules = {
  canBeDefault: (locale: TranslationLocale) => boolean;
  /** Why an unselected locale can't be added, or null when it can. */
  blockedReason: (args: {
    locale: TranslationLocale;
    selectedLocales: readonly TranslationLocale[];
  }) => string | null;
};

export const ANY_LOCALE_RULES: LocaleRules = {
  canBeDefault: () => true,
  blockedReason: () => null,
};
